import { Component, Input } from '@angular/core';

@Component({
  imports: [],
  selector: 'app-product-stock-message',
  standalone: true,
  styleUrls: ['./product-stock-message.component.scss'],
  templateUrl: 'product-stock-message.component.html',
})
export class AppProductStockMessageComponent {
  @Input() productStock: number | undefined;
  limitedQuantity: number = 5;
}
